export * from './ShapeRectVIcon';
export * from './ShapeRectVIcon16Light';
export * from './ShapeRectVIcon16Regular';
export * from './ShapeRectVIcon16Solid';
export * from './ShapeRectVIcon20Light';
export * from './ShapeRectVIcon20Regular';
export * from './ShapeRectVIcon20Solid';
export * from './ShapeRectVIcon24Regular';
export * from './ShapeRectVIcon24Solid';
export * from './ShapeRectVIcon32Regular';
export * from './ShapeRectVIcon64Regular';
